// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1a60S","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__3UY3h","gfeWrapper":"CalendarEvent_gfeWrapper__31Xml"};